import { SET_SIGN_OUT_IS_VISIBLE } from './constants';

export const setSignOutIsVisible = isVisible => ({
    type: SET_SIGN_OUT_IS_VISIBLE,
    isVisible,
});



// WEBPACK FOOTER //
// ./src/containers/Inputs/SignOut/actions.js